/* EdgePro edge-length helper.

   Default mode: 1 bracket per linear metre of edge. Unchanged.

   Height-aware mode (products carrying edgepro.allow_h_kn): spacing is
   calculated rather than assumed. Concrete thrust on a vertical form rises with
   the SQUARE of pour height,

       H = 0.5 * 24 * h^2   kN per linear metre   (24 kN/m3, full hydrostatic)

   so spacing = allowable horizontal per brace / H, capped at the product's
   maximum. A fixed one-per-metre rule is generous at 300 mm and not
   conservative enough at 1200 mm, which is why this exists. The allowable
   figure comes from the product datasheet and already carries its factor of
   safety.

   Writes into Dawn's quantity input and fires input + change so the tier strip
   and sticky buy bar totals follow. Bracket PDPs only. No dependencies. */
(function () {
  var CONCRETE_KN_M3 = 24;

  function init(el) {
    var sectionId = el.getAttribute('data-ep-lm-section');
    var moq = parseInt(el.getAttribute('data-ep-lm-moq'), 10);
    var step = parseInt(el.getAttribute('data-ep-lm-step'), 10);
    var cap = parseFloat(el.getAttribute('data-ep-lm-cap'));
    var maxSpacing = parseFloat(el.getAttribute('data-ep-lm-max'));
    if (!moq || moq < 1) moq = 1;
    if (!step || step < 1) step = 1;
    if (!isFinite(maxSpacing) || maxSpacing <= 0) maxSpacing = 1;

    var input = el.querySelector('.ep-lm__input');
    var heightInput = el.querySelector('[data-ep-lm-height]');
    var hint = el.querySelector('[data-ep-lm-hint]');
    var qtyInput = document.getElementById('Quantity-' + sectionId);
    if (!input || !qtyInput) return;

    var heightAware = isFinite(cap) && cap > 0 && !!heightInput;

    function spacingFor(h) {
      var thrust = 0.5 * CONCRETE_KN_M3 * h * h;
      if (thrust <= 0) return maxSpacing;
      return Math.min(maxSpacing, cap / thrust);
    }

    function suggest() {
      var metres = parseFloat(input.value);
      if (!isFinite(metres) || metres <= 0) {
        if (hint) {
          hint.textContent = heightAware
            ? 'Enter both to set the quantity.'
            : 'Enter your edge length to set the quantity.';
        }
        return;
      }

      var qty;
      var detail = '';

      if (heightAware) {
        var h = parseFloat(heightInput.value);
        if (!isFinite(h) || h <= 0) {
          if (hint) hint.textContent = 'Enter your pour height to set the quantity.';
          return;
        }
        var spacing = spacingFor(h);
        qty = Math.ceil(metres / spacing);
        detail =
          ' at ' +
          (Math.round(spacing * 100) / 100) +
          ' m centres for a ' +
          h +
          ' m pour';
      } else {
        qty = Math.ceil(metres);
      }

      if (qty < moq) qty = moq;
      qty = Math.ceil(qty / step) * step;

      qtyInput.value = qty;
      qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));

      if (hint) {
        hint.textContent =
          'Suggested quantity: ' +
          qty +
          (qty === 1 ? ' bracket' : ' brackets') +
          detail +
          '.';
      }
    }

    input.addEventListener('input', suggest);
    if (heightInput) heightInput.addEventListener('input', suggest);
  }

  document.querySelectorAll('[data-ep-linear-metre]').forEach(init);
})();
